module.exports = __webpack_public_path__ + "img/cctv-iisi.0506afdb.png";